var exports = {
  "E": "xdbfd91f1--060c9e--scrollable",
};

module.exports = exports;
